import axios, { AxiosResponse } from 'axios';
import Bottleneck from 'bottleneck';

import { Target, TargetRequest } from './Target';
import { MessageThread, MinimalTarget } from '@/generated/model';

const limiter = new Bottleneck({
  minTime: 5,
  maxConcurrent: 1,
});

let controllerTracking: AbortController | undefined = undefined;

export async function tracking(
  targets: TargetRequest[],
  popupTargetId: number | undefined,
  pathLengthMinutes: number | undefined
): Promise<AxiosResponse<Target[] | undefined>> {
  if (controllerTracking) {
    controllerTracking.abort();
  }
  controllerTracking = new AbortController();

  const baseUrl = '/api/v1.1/targets/positions/tracking';
  let queryString = '';
  if (popupTargetId && targets.find((t) => t.targetId === popupTargetId) !== undefined) {
    queryString = `?popupTargetId=${popupTargetId}`;
    if (pathLengthMinutes !== undefined) {
      queryString += `&pathLengthMinute=${pathLengthMinutes}`;
    }
  }

  return axios.post<Target[]>(baseUrl + queryString, targets, {
    signal: controllerTracking.signal,
  });
}

export async function abortTracking() {
  if (controllerTracking) {
    controllerTracking.abort();
    controllerTracking = undefined;
  }
  return;
}

export async function targetList(
  searchText: string | undefined,
  offset: number,
  limit: number
): Promise<AxiosResponse<MinimalTarget[] | undefined>> {
  const params = new URLSearchParams();
  params.append('offset', String(offset));
  params.append('limit', String(limit));
  if (searchText) {
    params.append('filter', searchText);
  }

  // FIXME kellene lassitas bele
  const url = `/api/v1.1/targets?${params.toString()}`;

  return limiter.schedule(() => axios.get<MinimalTarget[]>(url));
}

export async function trackedTargetLimit(): Promise<AxiosResponse<number | undefined>> {
  const url = '/api/v1.1/targets/trackedTargetLimit';

  return axios.get<number>(url);
}

export async function recentMessages() {
  const url = `/api/v1.1/messageThreads/recent?threadLimit=10&messagesByThreadLimit=1`;
  return axios.get<MessageThread[]>(url);
}

export async function chatMessages(name: string) {
  const url = `/api/v1.1/messageThreads/threadUser?name=${name}&messagesByThreadLimit=10`;
  return axios.get<MessageThread[]>(url);
}
